import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import Add_transaction from "../../Components/instructor_comp/add_transactions.js";
import Delete_transaction from "../../Components/instructor_comp/delete_transaction.js";

function Instructor_Transaction() {
  const [
    modalAdd_Instructor_TransactionIsOpen,
    setAdd_Instructor_TransactionModalIsOpen,
  ] = useState("");
  const [
    modalDelete_Instructor_TransactionIsOpen,
    setDelete_Instructor_TransactionIsOpen,
  ] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const status = [
    { value: "Pending", label: "Pending" },
    { value: "Paid", label: "Paid" },
  ];
  const type = [
    { value: "Workshop", label: "Workshop" },
    { value: "News", label: "News" },
    { value: "Blog", label: "Blog" },
  ];
  const openAdd_Instructor_Transaction = () => {
    closeAdd_Instructor_Transaction();
    setAdd_Instructor_TransactionModalIsOpen(true);
  };

  const closeAdd_Instructor_Transaction = () => {
    setAdd_Instructor_TransactionModalIsOpen(false);
  };
  const openDelete_Instructor_Transaction = (userId) => {
    setSelectedUserId(userId);
    closeDelete_Instructor_Transaction();
    setDelete_Instructor_TransactionIsOpen(true);
  };

  const closeDelete_Instructor_Transaction = () => {
    setDelete_Instructor_TransactionIsOpen(null);
  };
  return (
    <div>
      <Header></Header>
      {modalAdd_Instructor_TransactionIsOpen && (
        <openAdd_Instructor_Transaction
          onClose={closeAdd_Instructor_Transaction}
        />
      )}
      {modalDelete_Instructor_TransactionIsOpen && (
        <openDelete_Instructor_Transaction
          userId={selectedUserId}
          onClose={closeDelete_Instructor_Transaction}
        />
      )}

      {/* {modalAdd_AboutUsIsOpen && <Add_AboutUs onClose={closeAdd_AboutUs} />} */}

      <main id="main" class="main">
        <div class="pagetitle">
          <h1>Transaction</h1>
          <nav>
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="/categories">Home</a>
              </li>
              <li class="breadcrumb-item active">Transaction</li>
            </ol>
          </nav>
        </div>
        <section class="section"></section>
        <section class="section">
          <div class="card p-2">
            <div class="parent col-md-12 row mt-2">
              <div class="col-md-6">
                <div class="child">
                  <input
                    id="myInput"
                    type="text"
                    style={{
                      borderRadius: "5px",
                      height: "35px",
                      padding: "10px",
                      border: "1px solid lightgrey ",
                    }}
                    placeholder="Search..."
                  />
                </div>
                <div class="child ml-2">
                  <Select options={type} placeholder="Select Type"></Select>
                </div>
                <div class="child ml-2">
                  <Select options={status} placeholder="Select Status"></Select>
                </div>
              </div>
              <div class="col-md-6" style={{ textAlign: "right" }}>
                <div class="child">
                  <a>
                    {" "}
                    {/* <button
                      id="btnNewUser"
                      type="button"
                      data-toggle="modal"
                      data-target="#modalAdd"
                      class=" btn-round"
                      onClick={openAdd_transaction}
                    >
                      <i class="bi bi-person-add"></i> Add Transaction
                    </button> */}
                  </a>
                </div>
              </div>
            </div>
            <div
              style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}
            >
              {/* <TailSpin color="black" width={50} /> */}
            </div>
            <table class="table table-striped  ">
              <thead>
                <tr>
                  <th scope="col">Sr.No</th>
                  <th scope="col">Tittle</th>
                  <th scope="col">Workshop Name</th>

                  <th scope="col">Type</th>
                  <th scope="col">Slot</th>
                  <th scope="col">Seats</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Status</th>
                  {/* <th scope="col">Action</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                  {/* <td>
                    <div className="social-links mt-2">
                      { <button className="btn btn-warning btn-sm">
                        <i
                          className="fas fa-pencil-alt"
                          style={{ color: "#fff" }}
                        ></i>
                      </button> }
                      &nbsp;&nbsp;
                      <a onClick={openDelete_transaction}>
                        <i className="fas fa-trash-alt"></i>
                      </a>
                      &nbsp;
                    </div>
                  </td> */}
                </tr>
                <tr>
                  <th scope="row">2</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                </tr>
                <tr>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default Instructor_Transaction;
